<template>
  <div
    v-if="!contentStore || contentStore.isContentListFetching || fanStore.isFanFetching"
    class="container grid gap-y-12 pb-12 pt-4 lg:gap-y-16"
  >
    <PostSkeleton v-for="i in 3" :key="`skeleton-post-${i}`" />
  </div>
  <pre v-else-if="contentStore.contentListError">Error: {{ contentStore.contentListError }}</pre>
  <div v-else class="container grid gap-y-12 pb-12 pt-4 lg:gap-y-16">
    <Post
      v-for="post in contentStore.contentList"
      :key="post.id"
      :post="post"
      :clickable="true"
      :image="post.image_url"
      :fullscreen_allowed="false"
      :is-active="isPostActive(post.id)"
      ref="postRefs"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useFanStore } from '@stores/fan.store';
import { useContentStore } from '@stores/content.store';
import { useViewportVisibility } from '@/composables/useViewportVisibility';

import Post from '@modules/Post/Post.vue';
import PostSkeleton from '@modules/Post/PostSkeleton.vue';
import { useTelemetryFetcher } from '@api/tracking.api';

const postTelemetry = useTelemetryFetcher();
const contentStore = useContentStore();
const fanStore = useFanStore();
const { fanId } = storeToRefs(fanStore);

// Setup viewport visibility tracking
const postRefs = ref<HTMLElement[]>([]);
const { activeElement } = useViewportVisibility(postRefs);
// const updatePostRefs = computed(() => {
//   const elements = document.querySelectorAll('[data-post-id]') || [];
//   return Array.from(elements) as HTMLElement[];
// });
// const { activeElement } = useViewportVisibility(updatePostRefs);

// Helper function to check if a specific post is active
const isPostActive = (postId: string) => {
  const activePost = activeElement.value;
  return activePost?.dataset?.postId === postId;
};
// Update refs when content changes
watch(
  () => contentStore.contentList,
  () => {
    // Wait for next tick to ensure elements are mounted
    setTimeout(() => {
      const elements = document.querySelectorAll('[data-post-id]');
      postRefs.value = Array.from(elements) as HTMLElement[];
    }, 100);
  },
  { immediate: true },
);

watch(
  fanId,
  () => {
    if (fanId.value) {
      contentStore.fetchContentList();
      postTelemetry.execute({
        metric: 'view-feed',
        resource: window.location.href,
      });
    }
  },
  { immediate: true },
);
</script>
